import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import NutritionalAnalysisWorkspace, {
  type NutritionalAnalysisWorkspaceProps,
} from '@/pages/manual/nutritionalAnalysis/NutritionalAnalysisWorkspace';

type GenericMealPlanNutritionPageProps = Omit<
  NutritionalAnalysisWorkspaceProps,
  'planMode' | 'showSaveAsTemplateFlow' | 'templatesSearchPlaceholder'
>;

const extractClientIdFromPath = (path: string): string => {
  const match = path.match(/\/clients\/([^/?#]+)/);
  return match?.[1] ? decodeURIComponent(match[1]) : '';
};

export const GenericMealPlanNutritionRoutePage: React.FC = () => {
  const navigate = useNavigate();
  const { planId = '', dayNumber = '1' } = useParams<{ planId: string; dayNumber: string }>();
  const [searchParams] = useSearchParams();
  const fromPath = searchParams.get('from')?.trim() || '';
  const clientId = searchParams.get('clientId')?.trim() || extractClientIdFromPath(fromPath);
  const selectedDayNumber = Number(dayNumber) || 1;
  const backPath = fromPath.startsWith('/') ? fromPath : '/generic-meal-plans';

  return (
    <GenericMealPlanNutritionPage
      planId={planId}
      clientId={clientId}
      dayNumber={selectedDayNumber}
      onBack={() => navigate(backPath)}
    />
  );
};

const GenericMealPlanNutritionPage: React.FC<GenericMealPlanNutritionPageProps> = ({
  topBarBackLabel = 'Back',
  showClientSummaryStrip,
  ...props
}) => (
  <NutritionalAnalysisWorkspace
    {...props}
    planMode="generic"
    topBarBackLabel={topBarBackLabel}
    showClientSummaryStrip={showClientSummaryStrip ?? Boolean(props.clientId)}
  />
);

export default GenericMealPlanNutritionPage;
